export default "__VITE_ASSET__DwyjeBNG__"